import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ColorPickerModule } from 'primeng/colorpicker';

@Component({
  selector: 'crm-color-picker',
  standalone: true,
  imports: [CommonModule, ColorPickerModule, FormsModule],
  templateUrl: './color-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColorPickerComponent {
  public _color: string = '#ff0000';
  @Output() public colorChange = new EventEmitter<string>();
  @Input() public inline = true;

  @Input() public set color(color: string) {
    if (color?.length) {
      this._color = color;
    } else {
      this.colorChange.emit(this._color);
    }
  }
}
